import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from "./routes";
Vue.use(VueRouter);
/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation
 */

var Router = new VueRouter({
  scrollBehavior: function scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: routes,
  // Leave these as they are and change in quasar.conf.js instead!
  // quasar.conf.js -> build -> vueRouterMode
  // quasar.conf.js -> build -> publicPath
  mode: process.env.VUE_ROUTER_MODE,
  base: process.env.VUE_ROUTER_BASE
});
Router.beforeEach(function (to, from, next) {
  if (to.query.f === '0') {
    // if route is not finalized
    Object.keys(to.query).filter(function (key) {
      return to.query[key] === 'TOGGLE';
    }).forEach(function (toggleKey) {
      to.query[toggleKey] = Number(!Number(from.query[toggleKey]));
    });
    var toQuery = Object.assign({}, from.query, to.query);
    delete toQuery.f; // finalizing!

    next({
      path: to.path,
      query: toQuery
    });
  } else {
    // if finalized
    next();
  }
});
export default Router;